export const FIND_PRODUCT_BY_ID_REQUEST = "FIND_PRODUCT_BY_ID_REQUEST";
export const FIND_PRODUCT_BY_ID_SUCCESS = "FIND_PRODUCT_BY_ID_SUCCESS";
export const FIND_PRODUCT_BY_ID_FAILURE = "FIND_PRODUCT_BY_ID_FAILURE";

export const FIND_PRODUCTS_REQUEST = "FIND_PRODUCTS_REQUEST";
export const FIND_PRODUCTS_SUCCESS = "FIND_PRODUCTS_SUCCESS";
export const FIND_PRODUCTS_FAILURE = "FIND_PRODUCTS_FAILURE";

export const GET_PRODUCTS_BY_CATEGORY_REQUEST =
  "GET_PRODUCTS_BY_CATEGORY_REQUEST";
export const GET_PRODUCTS_BY_CATEGORY_SUCCESS =
  "GET_PRODUCTS_BY_CATEGORY_SUCCESS";
export const GET_PRODUCTS_BY_CATEGORY_FAILURE =
  "GET_PRODUCTS_BY_CATEGORY_FAILURE";

export const DELETE_PRODUCT_REQUEST = "DELETE_PRODUCT_REQUEST";
export const DELETE_PRODUCT_SUCCESS = "DELETE_PRODUCT_SUCCESS";
export const DELETE_PRODUCT_FAILURE = "DELETE_PRODUCT_FAILURE";

export const CREATE_PRODUCT_REQUEST = "CREATE_PRODUCT_REQUEST";
export const CREATE_PRODUCT_SUCCESS = "CREATE_PRODUCT_SUCCESS";
export const CREATE_PRODUCT_FAILURE = "CREATE_PRODUCT_FAILURE";

export const CREATE_RATING_REQUEST = "CREATE_RATING_REQUEST";
export const CREATE_RATING_SUCCESS = "CREATE_RATING_SUCCESS";
export const CREATE_RATING_FAILURE = "CREATE_RATING_FAILURE";

export const CREATE_REVIEW_REQUEST = "CREATE_REVIEW_REQUEST";
export const CREATE_REVIEW_SUCCESS = "CREATE_REVIEW_SUCCESS";
export const CREATE_REVIEW_FAILURE = "CREATE_REVIEW_FAILURE";

export const GET_PRODUCT_RATINGS_REQUEST = "GET_PRODUCT_RATINGS_REQUEST";
export const GET_PRODUCT_RATINGS_SUCCESS = "GET_PRODUCT_RATINGS_SUCCESS";
export const GET_PRODUCT_RATINGS_FAILURE = "GET_PRODUCT_RATINGS_FAILURE";

export const GET_PRODUCT_REVIEWS_REQUEST = "GET_PRODUCT_REVIEWS_REQUEST";
export const GET_PRODUCT_REVIEWS_SUCCESS = "GET_PRODUCT_REVIEWS_SUCCESS";
export const GET_PRODUCT_REVIEWS_FAILURE = "GET_PRODUCT_REVIEWS_FAILURE";
